// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../engines/components/BaseComponent";
import BaseStateSprite from "../../../../engines/components/state/BaseStateSprite";
import data_control from "../../../../engines/libs/data_control";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { NormalBackpackI, normalBackPackSaveI } from "../../manager/DefineInterface";
import BackpackPrefab from "./BackpackPrefab";

const {ccclass, property} = cc._decorator;

@ccclass
export default class BackpackInfoLayer extends BaseComponent {

	@property({ type: cc.Label, displayName:'' })
	labelPrice: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	touchNode: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelCount: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelDesc: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelName: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	btnList: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeContent: cc.Node = null;

	@property({ type: BaseStateSprite, displayName:'' })
	sprBg: BaseStateSprite = null;

    private backItem: normalBackPackSaveI = null;
    private itemConfig: NormalBackpackI = null;
    // LIFE-CYCLE CALLBACKS:
    private _parent: BackpackPrefab = null;
    // onLoad () {}

    start () {
        this.initTouchEvent(this.touchNode);
        this.touchNode._touchListener.setSwallowTouches(false);
    }

    showUI(
        _parent: BackpackPrefab
        , backItem: normalBackPackSaveI
        , goodsItem: cc.Node
    ) {
        this._parent = _parent;
        this.backItem = backItem;
        this.itemConfig = backPackEventMap()[this.backItem.backId];

        this.labelPrice.string = "单价：" + data_control.getNumberFormat(this.itemConfig.sellPrice);

        this.labelName.string = this.itemConfig.name;
        this.labelDesc.string = this.itemConfig.details;
        this.labelCount.string = '持有数量：' + data_control.getNumberFormat(backItem.num);

        let useAry:number[] = this.itemConfig.interactionType;
        let nameAry:string[] = this.itemConfig.interactionName;
        this.btnList.children.forEach((n:cc.Node,index:number)=>{
            if(useAry[index]!=null){
                n.active = true;
                let Label = n.getChildByName("label").getComponent(cc.Label);
                let str = nameAry[index];
                if(!str){
                    switch(useAry[index]){
                        case 0:{
                            str = "出售";
                            break;
                        }
                        case 1:{
                            str = "使用";
                            break;
                        }
                        case 2:{
                            str = "赠送";
                            break;
                        }
                    }
                }
                Label.string = str;
            }else{
                n.active = false;
            }
        });

        const topOffsetY = 16;
        const posSpacex = 40;
        let winSize = cc.winSize;
        let itemPos = goodsItem.convertToWorldSpaceAR(cc.v2());

        let ePosx = 0;
        let ePosy = 0;
        if (itemPos.x < winSize.width/2) {
            this.sprBg.node.scaleX = 1;
            ePosx = itemPos.x - posSpacex + this.node.width/2;
        } else {
            this.sprBg.node.scaleX = -1;
            ePosx = itemPos.x + posSpacex - this.node.width/2;
        }

        if (itemPos.y < winSize.height/2) {
            this.nodeContent.y = topOffsetY;
            this.sprBg.setFill(true);
            ePosy = itemPos.y + goodsItem.width/2 + 10;
        } else {
            this.nodeContent.y = 0;
            this.sprBg.setFill(false);
            ePosy = itemPos.y - goodsItem.width/2 - this.node.height + 20;
        }

        let epos = this.node.parent.convertToNodeSpaceAR(cc.v2(ePosx, ePosy));
        this.node.setPosition(epos);
    }

    onBtnLayoutBtn(e:cc.Event.EventTouch,custom:string) {
        this._parent.onBtnLayoutBtn(e, custom);
    }

    touchEventEnd(event: cc.Event.EventTouch){
        this.node.parent.active = false;

        
    }
    // update (dt) {}
}
